import 'twin.macro'
import 'styled-components/macro'
import GlobalStyles from './GlobalStyles'
import { useState } from 'react'
import { Button } from '@getcircuit/components'
import { MarketingTypography } from './MarketingTypography'
import { CardboardTypography } from './CardboardTypography'

function App() {
  const [dark, setDark] = useState(false)

  return (
    <div tw="max-w-6xl m-auto font-brand">
      <GlobalStyles dark={dark} />
      <div tw="space-y-10 pt-10 text-default-neutral">
        <div tw="flex justify-between">
          <h1 tw="text-title-default">Cardboard Tailwind</h1>

          <Button variation="secondary" onClick={() => setDark(!dark)}>
            {dark ? 'Go Light' : 'Go Dark'}
          </Button>
        </div>

        <CardboardTypography />
        <hr />
        <MarketingTypography />
      </div>
    </div>
  )
}

export default App
